import { useEffect, useState } from 'react';
import { useMapContext } from '@uiw/react-baidu-map-map';
import { useProperties, useVisiable } from '@uiw/react-baidu-map-utils';
export function useCopyrightControl(props) {
  if (props === void 0) {
    props = {};
  }
  var [copyrightControl, setCopyrightControl] = useState();
  var {
    anchor,
    offset
  } = props;
  var {
    map
  } = useMapContext();
  useEffect(() => {
    if (map && !copyrightControl) {
      var instance = new BMap.CopyrightControl({
        anchor: anchor || BMAP_ANCHOR_TOP_RIGHT,
        offset
      });
      map.addControl(instance);
      setCopyrightControl(instance);
    }
    return () => {
      if (map && copyrightControl) {
        map.removeControl(copyrightControl);
      }
    };
  }, [map, copyrightControl, anchor, offset]);
  useVisiable(copyrightControl, props);
  useProperties(copyrightControl, props, ['Anchor', 'Offset']);
  return {
    copyrightControl,
    setCopyrightControl
  };
}